import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import AforoView from "./AforoView";
import ConfirmationMessage from "../../components/confirmationMessage";
import {CatalogService} from "../../service/catalog/CatalogService";
import {AforoService} from "../../service/maintenance/aforo/AforoService";
import {
    rateMultipliedByOneHundredDataTableTemplate,
    validateNumberIntegersDecimals
} from "../../utils/formatters/Numbers";
import {Column} from "primereact/column";
import {Button} from "primereact/button";

export default class AforoContainer extends Component {
    constructor(props) {
        super(props);

        let columns = [
            {field: "tipoAforo", header: "Tipo Aforo", style: {textAlign: 'left'}},
            {field: "emisoraPrestamo", header: "Emisora a Prestar", style: {textAlign: 'left'}},
            {field: "emisoraGarantia", header: "Garantía", style: {textAlign: 'left'}},
            {
                field: "porcAforo", header: "Porcentaje Requerido", style: {textAlign: 'right'},
                body: rateMultipliedByOneHundredDataTableTemplate
            },
        ];

        this.aforoService = new AforoService();
        this.catalogService = new CatalogService();
        this.getDataAforos = this.getDataAforos.bind(this);
        this.getAforos = this.getAforos.bind(this);
        this.getInstrumentLend = this.getInstrumentLend.bind(this);
        this.getGuarantees = this.getGuarantees.bind(this);
        this.onPage = this.onPage.bind(this);

        this.confirmationRef = null;
        this.indexTable = React.createRef();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            cols: columns,
            isReport: props.isReport,
            aforos: this.getAforos(),
            instrumentsLend: this.getInstrumentLend(),
            guarantees: this.getGuarantees(),
            isLoading: false,
            filters: {
                typeObj: {},
                instrumentObj: {},
                guaranteeObj: {},
                call: "",
            },
            dataAforos: [],
            displayDialog: false,
            aforoSelected: {},
            first: 0,
            rows: 15,
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.maintenanceAforoActionTemplate = this.maintenanceAforoActionTemplate.bind(this);
        this.openDialogEditAforo = this.openDialogEditAforo.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.saveAforo = this.saveAforo.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
        if (!this.state.isReport) {
            let colsAux = this.state.cols;
            colsAux = colsAux.concat({
                header: "Acciones", style: {textAlign: 'right'},
                body: this.maintenanceAforoActionTemplate
            });
            this.setState({cols: colsAux});
        }
    }

    maintenanceAforoActionTemplate(rowData, column) {
        let dataSelected = JSON.parse(JSON.stringify(rowData));
        return (
            <Button label="Editar"
                    onClick={() => this.openDialogEditAforo(dataSelected)}
            />
        );
    }

    openDialogEditAforo(rowSelected) {
        let rowSelectedAux = rowSelected;
        rowSelected['porcAforo'] = rowSelected['porcAforo'] * 100;
        this.setState({
            displayDialog: true,
            aforoSelected: rowSelectedAux,
        })
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        this.setState({
            filters: {
                typeObj: {},
                instrumentObj: {},
                guaranteeObj: {},
                call: "",
            },
        });
    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;
        const {name, value} = event.target;
        if (name === 'typeObj') {
            filtersAux['call'] = value['porcTipoAforo'];
        }
        filtersAux[name] = value;
        this.setState({
            filters: filtersAux,
        });
    }

    onChangeInput(event) {
        const {name, value, id} = event.target;
        let aforoSelectedAux = this.state.aforoSelected;
        let newValue = validateNumberIntegersDecimals(Number(value), id, 2);
        aforoSelectedAux[name] = newValue;
        this.setState({
            aforoSelected: aforoSelectedAux,
        });
    }

    saveAforo() {
        if (this.state.aforoSelected.porcAforo === "" ||
            this.state.aforoSelected.porcAforo === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Llenar el campo requerido correctamente'
            });
        } else {
            this.loading(true);
            this.aforoService.updateAforo(this.state.aforoSelected)
                .then(resp => {
                    if (resp.error !== "") {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: resp.error
                        });
                    } else {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: "Se ha actualizado su solicitud con éxito."
                        });
                    }
                    this.getDataAforos();
                    this.onHideDialog();
                    this.loading(false);
                });
        }
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getAforos() {
        this.loading(true);
        this.catalogService.getCatalogAforo()
            .then(aforos => {
                this.setState({
                    aforos: aforos,
                });
                this.loading(false)
            });
    }

    getInstrumentLend() {
        this.loading(true);
        this.catalogService.getCatalogInstrumentLend()
            .then(instruments => {
                this.setState({
                    instrumentsLend: instruments,
                });
                this.loading(false)
            });
    }

    getGuarantees() {
        this.loading(true);
        this.catalogService.getCatalogGuarantees()
            .then(guarantees => {
                this.setState({
                    guarantees: guarantees,
                });
                this.loading(false)
            });
    }

    getDataAforos() {
        this.loading(true);
        this.setState({
            disabledSearchButton: true,
        });
        this.aforoService.getDataAforo(
            this.state.filters.typeObj.idTipoAforo,
            this.state.filters.instrumentObj.emisoraPrestamo,
            this.state.filters.guaranteeObj.emisoraGarantia,
            this.state.first,
            this.state.rows,
        ).then(resp => {
            if (resp.error !== '') {
                this.growl.show({
                    severity: 'info', summary: 'Atención.',
                    detail: resp.error
                });
            } else {
                this.setState({
                    dataAforos: resp.payload,
                    totalRecords: resp.payload.length > 0 ? resp.payload[0].total : 0,
                });
            }
            this.indexTable.current.setState({first: 0,});
            this.loading(false);
            this.setState({disabledSearchButton: false,});
        });
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    onPage(event) {
        this.setState({
            first: event.first,
        });
        this.getDataAforos();
    }

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Editar Aforo</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.saveAforo}/>
                </div>
            </div>;

        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field ? col.field : ''}
                           header={col.header}
                           style={col.style ? col.style : ''}
                           sortable={true}
                           body={col.body ? col.body : ''}
            />;
        });
        const {
            dataAforos, isLoading, filters, isReport, aforos, instrumentsLend, guarantees,
            aforoSelected, displayDialog, disabledSearchButton
        } = this.state;

        return <AforoView
            dataAforos={dataAforos}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            filters={filters}
            confMsg={confMsg}
            isReport={isReport}
            aforos={aforos}
            guarantees={guarantees}
            instrumentsLend={instrumentsLend}
            columns={columns}
            aforoSelected={aforoSelected}
            displayDialog={displayDialog}
            dialogHeader={dialogHeader}
            disabledSearchButton={disabledSearchButton}
            indexTable={this.indexTable}
            onChangeFilters={this.onChangeFilters}
            getDataAforos={this.getDataAforos}
            clearFilters={this.clearFilters}
            onHideDialog={this.onHideDialog}
            onChangeInput={this.onChangeInput}
            first={this.state.first}
            onPage={this.onPage}
            rows={this.state.rows}
            totalRecords={this.state.totalRecords}
        />
    }
};